module.exports = __webpack_public_path__ + "../resources/images/connectionError-a74177096e79d8de21fd3de9e30d2b44.svg";